
import { createStore } from 'vuex'
import saveModule from './modules/saveModule'
import fonteDadosModule from './modules/fonteDadosModule'
import { Buffer } from 'buffer';

export const createStoreVistra = (app) => {

    //em modo integração o navegador pode estar bloqueando local/session storage dando erro ao ler/gravar

    const getLocalStorageItem = (name) => {
        try {
            return localStorage.getItem(name)
        } catch {
            return null
        }
    }

    const setLocalStorageItem = (name, value) => {
        app.config.globalProperties.$vistra.Contexto.setLocalStorageItem(name, value)
    }

    const removeLocalStorageItem = (name) => {
        app.config.globalProperties.$vistra.Contexto.removeLocalStorageItem(name)
    }

    const setSessionStorageItem = (name, value) => {
        app.config.globalProperties.$vistra.Contexto.setSessionStorageItem(name, value)
    }

    const removeSessionStorageItem = (name) => {
        try {
            return sessionStorage.removeItem(name)
        } catch {
            return null
        }
    }    

    return createStore({
        state: {
            status: '',
            token: getLocalStorageItem('vistra_token') || '',
            tokenExpiration: getLocalStorageItem('vistra_token_expiracao'),
            usuario: (() => {
                let aux = getLocalStorageItem('usuario') ? JSON.parse(getLocalStorageItem('usuario')) : null
                if (!aux)
                    aux = {
                        id: "",
                        nome: "",
                        imagem: "",
                        idioma: "",
                        idEmpresa: 0,
                        tema: ""
                    }
                if (!aux.idioma)
                    aux.idioma = navigator.language.substring(0, 2)
                if (!aux.imagem)
                    aux.imagem = "/assets/images/user-1.png"
                else
                    aux.imagem = aux.imagem.startsWith("data:image") ? aux.imagem : ("data:image/png;base64," + aux.imagem)
                return aux
            })(),
            empresas: getLocalStorageItem('empresas') ? JSON.parse(getLocalStorageItem('empresas')) : [],
            idEmpresa: getLocalStorageItem('idEmpresa'),
            tema: getLocalStorageItem('vistra-tema'),
            logos: {
                menuClaro: getLocalStorageItem('vistra-logo-menuClaro') || "/assets/images/logo-menu.png",
                menuEscuro: getLocalStorageItem('vistra-logo-menuEscuro') || "/assets/images/logo-menu-dark.png",
                login: getLocalStorageItem('vistra-logo-login') || "/assets/images/logo-login.png",
                marketing: getLocalStorageItem('vistra-logo-imagemMarketing') || "/assets/images/bg-marketing-empty.png",
            },
            msgSistema: null,
            sistema: {
                versao: '...',
                ano: '...',
                liberado: true,
                bloqueado: false,
                enviroment: 'PRODUCTION',
                dk: false,
                os: '',
                bancoConectado: true
            },
            infoReport: {},
            infoVistraIA: {},
            configuracaoGeralServicos: {},
            isOnline: navigator.onLine || false,
            signalRStatus: 'desconectado',
            integracao: false,
            permissaoSistemaCompletoIntegracao: false,
            itensMenuMobileAtivo: [],
            empresaContextoTemIA: false,
            linkChangeLogs: [{}],
            dataSetSqlQuery: false,
            requisitaToggleMenu: {
                handler: 0,
                open: false
            },
            content: {
                id: 'vdr-painel', //se mudar aqui, mudar tb no slyte do painel.vue, afeta tambem no arquivo "lista_objetos2.vue",
                tamanho: {
                    original: null,
                    atual: null
                }
            },
            contentResized: {
                tamanho: null,
                handler: 0
            },
            carregouDoBanco: false,
            paletasCores: [],
            painelMudouTema: {
                handler: 0
            },
        },

        mutations: {
            setItensMenuMobileAtivo(state, payload) {
                state.itensMenuMobileAtivo = payload
            },
            setIntegracao(state, payload) {
                state.integracao = payload
            },
            setPermissaoSistemaCompletoIntegracao(state, payload){
                state.permissaoSistemaCompletoIntegracao = payload
            },
            atualizaState(state) {
                //console.unicorn('###atualizaState', 'isLoggedIn', state.isLoggedIn)
                if (state.integracao) return
                
                //pra entrar em watch nem refazer computed sem precisar 
                let aplicaSeMudou = function (prop, valor) {
                    if (JSON.stringify(state[prop]) != JSON.stringify(valor))
                        state[prop] = valor
                }
                aplicaSeMudou("token", getLocalStorageItem('vistra_token') || '')
                aplicaSeMudou("usuario", getLocalStorageItem('usuario') ? JSON.parse(getLocalStorageItem('usuario')) : null)
                aplicaSeMudou("empresas", getLocalStorageItem('empresas') ? JSON.parse(getLocalStorageItem('empresas')) : [])
                aplicaSeMudou("idEmpresa", getLocalStorageItem('idEmpresa') ? parseInt(getLocalStorageItem('idEmpresa')) : 0)
            },

            auth_request(state) {
                state.status = 'loading'
            },
            auth_success(state, token) {
                // if (!state.integracao) {
                    setLocalStorageItem('vistra_token', token)
                    setLocalStorageItem('vistra_data_token', new Date())
                // }
                
                // if (state.permissaoSistemaCompletoIntegracao) {
                //     setLocalStorageItem('vistra_token', token)
                //     setLocalStorageItem('vistra_data_token', new Date())
                // }
                state.status = 'success'
                state.token = token
                
                const tokenParts = token.split(".");
                const payload = JSON.parse(Buffer.from(tokenParts[1], 'base64'));
                const expiracao = app.config.globalProperties.$vistra.addMinutes(payload.MinutosParaRenovacao)
                if (!state.integracao) 
                    setLocalStorageItem('vistra_token_expiracao', expiracao)
                state.tokenExpiration = expiracao
            },
            auth_error(state) {
                removeLocalStorageItem('vistra_token')
                removeLocalStorageItem('vistra_token_expiracao')
                removeLocalStorageItem('usuario')
                removeLocalStorageItem('localization')
                state.status = 'error'
            },
            msg_Sistema(state, msg) {
                if (state.integracao) return
                setSessionStorageItem('msgSistema', msg);
                removeSessionStorageItem('msgSistemaProximaExibicao');
                removeSessionStorageItem('msgSistemaUltima');
                state.msgSistema = msg
            },
            msg_SistemaReset(state) {
                state.msgSistema = undefined
            },
            setDadosUsuario(state, usuario) {
                if (!usuario) {
                    removeLocalStorageItem('usuario')
                } else {
                    if (!usuario.idioma)
                        usuario.idioma = navigator.language.substring(0, 2)
                    if (!usuario.imagem)
                        usuario.imagem = "/assets/images/user-1.png"
                    else
                        usuario.imagem = (usuario.imagem.startsWith("data:image") || usuario.imagem.startsWith("/assets")) ? usuario.imagem : ("data:image/png;base64," + usuario.imagem)   
                    
                    state.usuario = usuario
                    setLocalStorageItem('historicoCores', [])
                    setLocalStorageItem('localization', "")
                    setLocalStorageItem('usuario', JSON.stringify(usuario))
                }

            },
            logout(state) {
                state.status = ''
                state.token = '',
                state.usuario = {}
            },
            empresaContexto(state, id) {
                setLocalStorageItem('idEmpresa', id)
                state.idEmpresa = parseInt(id)
            },
            empresas(state, emps) {
                setLocalStorageItem('empresas', emps)
                state.empresas = emps ? JSON.parse(emps) : []
            },
            tema(state, payload) {
                if (payload.gravaNoStorage)
                    setLocalStorageItem('vistra-tema', payload.tema)
                const html = document.querySelector("html");

                if (html) {
                    if (payload.tema === "tema-dark" && !html.classList.contains("dark"))
                        html.classList.add("dark");

                    if (payload.tema === "tema" && html.classList.contains("dark"))
                        html.classList.remove("dark");
                }
                state.tema = payload.tema
            },
            setTema(state, payload) {
                state.tema = payload
            },
            salvaLogo(state, logo){
                if (logo.imagem) {
                    state.logos[logo.nome] = undefined //pra ativar o watch no getter
                    if (!logo.imagem.startsWith("data:image/png;base64,"))
                        logo.imagem = "data:image/png;base64," + logo.imagem
                    setLocalStorageItem(`vistra-logo-${logo.nome}`, logo.imagem)
                    state.logos[logo.nome] = logo.imagem
                }
            },
            setSistema(state, value) {
                state.sistema = value
                setLocalStorageItem("versaoSistema", value.versao)
            },
            setInfoReport(state, value) {
                state.infoReport = value
            },
            setStateServiceIsUpReport(state, value) {
                state.infoReport.serviceIsUp = value
            },
            setInfoVistraIA(state, value) {
                state.infoVistraIA = value
            },
            setConfiguracaoGeralServicos(state, value) {
                state.configuracaoGeralServicos = value
            },
            setOnlineStatus(state, value) {
                state.isOnline = value
            },
            setSignalRStatus(state, value) {
                //console.show("SignalRStatus", value)
                state.signalRStatus = value
            },
            setLinkChangeLogs(state, value){
                state.linkChangeLogs = value
            },
            setRequisitaToggleMenu: (state) => {
                state.requisitaToggleMenu =  {
                    handler: Math.random(),
                    open: !state.requisitaToggleMenu.open
                }
            },
            contentResize: (state, payload) => {
                state.content.tamanho.atual = payload

                //evento
                state.contentResized = {
                    tamanho: payload,
                    handler: Math.random()
                };
            },
            setPaletas(state, payload){
                state.paletasCores = payload;
            },

            setCarregouDoBanco(state, payload){
                state.carregouDoBanco = payload
            },
            painelSetMudaTema: (state) => {
                state.painelMudouTema = Math.random();
            },
        },
        actions: {
            setItensMenuMobileAtivo({ commit }, payload) {
                commit('setItensMenuMobileAtivo', payload)
            },
            setIntegracao({ commit }, payload) {
                commit('setIntegracao', payload)
            },

            setPermissaoSistemaCompletoIntegracao({ commit }, payload) {
                commit('setPermissaoSistemaCompletoIntegracao', payload)
            },

            atualizaState({ commit }) {
                commit('atualizaState')
            },

            empresaContexto({ commit }, id) {
                commit('empresaContexto', id)
            },

            temaVistra({ commit }, modoEscuro) {
                commit('tema', {
                    tema: modoEscuro ? "tema-dark" : "tema",
                    gravaNoStorage: true
                })
            },
            
            temaVistraLocal({ commit }, modoEscuro) {
                commit('tema', {
                    tema: modoEscuro ? "tema-dark" : "tema",
                    gravaNoStorage: false
                })
            },

            empresas({ commit, state }, emps) {
                commit('empresas', emps)
            },

            setDadosUsuario({ commit, dispatch }, usuario) {
                commit('setDadosUsuario', usuario)
                if(usuario)
                    dispatch('temaVistra', usuario.modoEscuro)
            },

            updateToken({ commit }, token) {
                commit('auth_success', token)
            },

            login({ commit, dispatch }, usuario) {
                return new Promise((resolve, reject) => {
                    commit('auth_request')
                    app.config.globalProperties.$http.post('/Usuario/Login', usuario)
                        .then(resp => {

                            if (!dispatch('doLogin', resp))
                                reject();
                            resolve(resp)
                        })
                        .catch(err => {
                            commit('auth_error')
                            reject(err)
                        })
                })
            },
            autoLogin({ commit, dispatch }, { chave, rt }) {
                return new Promise((resolve, reject) => {
                    commit('auth_request');
    
                    (() => {
                        if (rt) {
                            commit('auth_success', chave);
                            return app.config.globalProperties.$http.post('/Usuario/ValidaToken', { token: chave, refreshToken: rt })
                        }
                        return app.config.globalProperties.$http.post('/Usuario/ValidaAutoLogin', { chave })
                    })().then(resp => {
    
                            if (!dispatch('doLogin', resp))
                                reject();

                            resolve(resp)
                        })
                        .catch(err => {
                            commit('auth_error')
                            reject(err)
                        })
                })
            },
            doLogin({ commit, state }, resp) {
                if (resp.data === 401) {
                    commit('auth_error')
                    return false;
                }
                
                let token = resp.data.token
                var usr = { ...resp.data.usuario, ...resp.data.dispositivo }
                usr.idioma = resp.data.idioma
    
                commit('auth_success', token)
                commit('setDadosUsuario', usr)
                if (resp.data.idEmpresaContexto)
                    commit('empresaContexto', resp.data.idEmpresaContexto)
                // commit('tema', usr.modoEscuro ? "tema-dark" : "tema")
    
                //commit('msg_Sistema', resp.data.msgSistema);
                try {
                    if (resp.data.msgSistema)
                        setSessionStorageItem('msgSistema', resp.data.msgSistema);
                    else
                        removeSessionStorageItem('msgSistema');
        
                    removeSessionStorageItem('msgSistemaProximaExibicao');
                    removeSessionStorageItem('msgSistemaUltima');
                } catch {}
    
                return true;
            },

            logout({ commit }) {
                return new Promise((resolve, reject) => {
                    commit('logout')
                    removeLocalStorageItem('vistra_token')
                    removeLocalStorageItem('vistra_token_expiracao')
                    removeLocalStorageItem('usuario')
                    removeLocalStorageItem('vemDoLogin')
                    resolve()
                })
            },

            logoutStore({ commit }) {
                commit('logout')
            },

            carregaLogo({ commit }, payload){
                app.config.globalProperties.$http.get("/Logos/CarregaImagem/" + payload)
                .then(response => {
                    switch (payload) {
                        case 1:
                            commit('salvaLogo', { nome: 'login', imagem: response.data.logo })
                            break;
                        case 2:
                            commit('salvaLogo', { nome: 'menuClaro', imagem: response.data.logo })
                            break;
                        case 3:
                            commit('salvaLogo', { nome: 'menuEscuro', imagem: response.data.logo })
                            break;
                        case 4:
                            commit('salvaLogo', { nome: 'imagemMarketing', imagem: response.data.logo })
                            break;
                    }
                })
            },

            setSistema( { commit }, payload) {
                commit('setSistema', payload)
            },

            setInfoReport( { commit }, payload) {
                commit('setInfoReport', payload)
            },

            setStateServiceIsUpReport( { commit }, payload) {
                commit('setStateServiceIsUpReport', payload)
            },

            setInfoVistraIA( { commit }, payload) {
                commit('setInfoVistraIA', payload)
            },
            setConfiguracaoGeralServicos( { commit }, payload) {
                commit('setConfiguracaoGeralServicos', payload)
            },

            setOnlineStatus( { commit }, payload) {
                commit('setOnlineStatus', payload)
            },

            setSignalRStatus( { commit }, payload) {
                commit('setSignalRStatus', payload)
            },
            setLinkChangeLogs( { commit }, payload) {
                commit('setLinkChangeLogs', payload)
            },
            carregarPaletas({ commit }){
                app.config.globalProperties.$http.get("/Paleta/CarregarPaletas")
                    .then(response => {
                        commit('setPaletas', response.data);
                        commit('setCarregouDoBanco', true)
                    })
                    .catch(err => console.log(err))
            },
            setPaletas({ commit }, payload){
                commit('setPaletas', payload)
            }
        },

        getters: {
            integracao: state => state.integracao,
            permissaoSistemaCompletoIntegracao: state => state.permissaoSistemaCompletoIntegracao,
            logos: state => state.logos,
            isLoggedIn: state => !!state.token,
            token: state => state.token,
            tokenExpiration: state => state.tokenExpiration,
            msgSistema: state => state.msgSistema,
            sistema: state => state.sistema,
            authStatus: state => state.status,
            usuario: (state) => state.usuario,
            idioma: (state) => {
                try {
                    return sessionStorage.getItem("idioma") || state.usuario?.idioma
                } catch {
                    return state.usuario?.idioma
                }
            },
            idEmpresa: state => state.idEmpresa || (state.usuario && state.usuario.idsEmpresas && state.usuario.idsEmpresas.lenth && state.usuario.idsEmpresas[0].id) || 0,
            empresas: state => state.empresas || [],
            tema: state => state.tema || (state.usuario && (state.usuario.modoEscuro ? "tema-dark" : "tema")) || "tema",
            isOnline: state => state.isOnline,
            signalRStatus: state => state.signalRStatus,
            itensMenuMobileAtivo: state => state.itensMenuMobileAtivo,
            configuracaoGeralServicos: state => state.configuracaoGeralServicos,
            empresaContextoTemIA: (state) => state.empresas.find(empresa => empresa.id === state.idEmpresa).vistraIAAtivo,
            linkChangeLogs: (state) => state.linkChangeLogs,
            onRequisitaToggleMenu: state => state.requisitaToggleMenu,
            onContentResized: state => state.contentResized,
            content: state => state.content,
            carregouDoBanco: state => state.carregouDoBanco,
            paletasCores: state => state.paletasCores,
            onPainelMudouTema: state => state.painelMudouTema,
        },
        modules: {
            saveModule,
            fonteDadosModule
        }
    })
}
